const H = {
  pretty: {
    int(number) {
        return new Intl.NumberFormat('de-DE').format(number)
    },
    date(dateString){
        const months = [
            'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
            'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
        ];
    
        const dateObj = new Date(dateString);
    
        const day = dateObj.getDate();
        const month = months[dateObj.getMonth()];
        const hours = dateObj.getHours().toString().padStart(2, '0');
        const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    
        return `${day} de ${month}, às ${hours}:${minutes}`;
    },
    money(value){
      if (!value) return value;
      const numericValue = `${value}`?.replace(/\D/g, "");
      const integerPart = numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
      const decimalPart = numericValue.slice(-2);
    
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    
      return `${formattedInteger},${decimalPart}`;
    }
  },
};

export default H;
